// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_content__Bs6Ok {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  z-index: var(--z-index-overlay-confirm);
}

.styles_backdrop__MrDrq {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: var(--z-index-overlay-confirm);
  background: var(--color-gray-font);
  filter: opacity(0);
  transition: all ease-in 0.3s;
}

.styles_actionConfirm__Hgvy3 {
  z-index: var(--z-index-modal-confirm);
  background: var(--bg-main);
  border-radius: var(--border-radius-lg);
  transform: scale(0);
  transition: all ease-in 0.3s;
  min-width: 300px;
  padding: 0.5rem;
}
.styles_actionConfirm__Hgvy3.styles_animate__R83PH {
  animation: styles_zoomin__JIO1T 0.4s linear;
  animation-iteration-count: 1;
}
.styles_actionConfirm__Hgvy3 .styles_title__7-3PY {
  text-align: center;
}
.styles_actionConfirm__Hgvy3 .styles_description__6NM2y {
  font-size: 18px;
  width: 100%;
  text-align: center;
  padding: 1rem;
  margin: 0;
}
.styles_actionConfirm__Hgvy3 .styles_butons__NNLWo {
  display: flex;
  justify-content: space-between;
  padding: 1rem 1rem;
  padding-top: 0;
}
.styles_actionConfirm__Hgvy3 .styles_butons__NNLWo button {
  width: 45%;
}

@keyframes styles_zoomin__JIO1T {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
.styles_contentActive__WRu\\+Q {
  pointer-events: initial;
}
.styles_contentActive__WRu\\+Q .styles_backdrop__MrDrq {
  filter: opacity(0.5);
}
.styles_contentActive__WRu\\+Q .styles_actionConfirm__Hgvy3 {
  transform: scale(1);
}`, "",{"version":3,"sources":["webpack://./../../shared/src/componets/feedback/ActionConfirm/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,uCAAA;AACJ;;AAEA;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,uCAAA;EACA,kCAAA;EACA,kBAAA;EACA,4BAAA;AACJ;;AAEA;EACI,qCAAA;EACA,0BAAA;EACA,sCAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;AACJ;AACI;EACI,2CAAA;EACA,4BAAA;AACR;AAGI;EACI,kBAAA;AADR;AAII;EACI,eAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AAFR;AAKI;EACI,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;AAHR;AAKQ;EACI,UAAA;AAHZ;;AAQA;EACI;IACI,mBAAA;EALN;EAQE;IACI,qBAAA;EANN;EAUE;IACI,mBAAA;EARN;AACF;AAaA;EACI,uBAAA;AAXJ;AAaI;EACI,oBAAA;AAXR;AAcI;EACI,mBAAA;AAZR","sourcesContent":[".content {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    pointer-events: none;\n    z-index: var(--z-index-overlay-confirm);\n}\n\n.backdrop {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: var(--z-index-overlay-confirm);\n    background: var(--color-gray-font);\n    filter: opacity(0.0);\n    transition: all ease-in .3s;\n}\n\n.actionConfirm {\n    z-index: var(--z-index-modal-confirm);\n    background: var(--bg-main);\n    border-radius: var(--border-radius-lg);\n    transform: scale(0);\n    transition: all ease-in .3s;\n    min-width: 300px;\n    padding: .5rem;\n\n    &.animate {\n        animation: zoomin .4s linear;\n        animation-iteration-count: 1;\n\n    }\n\n    .title {\n        text-align: center;\n    }\n\n    .description {\n        font-size: 18px;\n        width: 100%;\n        text-align: center;\n        padding: 1rem;\n        margin: 0;\n    }\n\n    .butons {\n        display: flex;\n        justify-content: space-between;\n        padding: 1rem 1rem;\n        padding-top: 0;\n\n        button {\n            width: 45%;\n        }\n    }\n}\n\n@keyframes zoomin {\n    0% {\n        transform: scale(1);\n    }\n\n    50% {\n        transform: scale(1.1);\n    }\n\n\n    100% {\n        transform: scale(1);\n    }\n}\n\n\n\n.contentActive {\n    pointer-events: initial;\n\n    .backdrop {\n        filter: opacity(0.5);\n    }\n\n    .actionConfirm {\n        transform: scale(1);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `styles_content__Bs6Ok`,
	"backdrop": `styles_backdrop__MrDrq`,
	"actionConfirm": `styles_actionConfirm__Hgvy3`,
	"animate": `styles_animate__R83PH`,
	"zoomin": `styles_zoomin__JIO1T`,
	"title": `styles_title__7-3PY`,
	"description": `styles_description__6NM2y`,
	"butons": `styles_butons__NNLWo`,
	"contentActive": `styles_contentActive__WRu+Q`
};
export default ___CSS_LOADER_EXPORT___;
